module.exports = __webpack_public_path__ + "77e2cff3fc396695b704c7fe1071e82f.png";